var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRecording = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.00781V7.01563C10 7.28125 9.89828 7.51563 9.69484 7.71875C9.50704 7.90625 9.28013 8 9.01408 8H0.985915C0.719875 8 0.485133 7.90625 0.28169 7.71875C0.0938967 7.51563 0 7.28125 0 7.01563V1.00781C0 0.742187 0.0938967 0.507813 0.28169 0.304688C0.485133 0.101563 0.719875 0 0.985915 0H9.01408C9.28013 0 9.50704 0.101563 9.69484 0.304688C9.89828 0.507813 10 0.742187 10 1.00781ZM6.99531 4L3.99061 2.38281V5.64062L6.99531 4ZM1 0.5H3V1H1V0.5ZM6 0.5H4V1H6V0.5ZM7 0.5H9V1H7V0.5ZM3 7H1V7.5H3V7ZM4 7H6V7.5H4V7ZM9 7H7V7.5H9V7Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRecording);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-recording.75438b9beac4125ce94787ac9fcea39e.svg";